import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=051dcd6f&scoped=true"
import script from "./Gauge.vue?vue&type=script&lang=js"
export * from "./Gauge.vue?vue&type=script&lang=js"
import style0 from "./Gauge.vue?vue&type=style&index=0&id=051dcd6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051dcd6f",
  null
  
)

export default component.exports